// @flow

export const UPDATE_PASSWORD: string = 'UPDATE_PASSWORD';
export const UPDATE_PASSWORD_ERROR: string = 'UPDATE_PASSWORD_ERROR';
export const UPDATE_PASSWORD_SUCCESS: string = 'UPDATE_PASSWORD_SUCCESS';
